
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $5DwXE = parcelRequire("5DwXE");
parcelRequire("fXDXi");

var $4mWlF = parcelRequire("4mWlF");

var $dpRHA = parcelRequire("dpRHA");

var $9DiKA = parcelRequire("9DiKA");

var $3p15R = parcelRequire("3p15R");

var $4IEkJ = parcelRequire("4IEkJ");

var $2Jpez = parcelRequire("2Jpez");

var $lrKvI = parcelRequire("lrKvI");

var $c3RIb = parcelRequire("c3RIb");

var $9jDAx = parcelRequire("9jDAx");

var $bV0pP = parcelRequire("bV0pP");
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $7a958506415603f3$var$projection = (0, $dpRHA.get)("EPSG:3857");
console.assert($7a958506415603f3$var$projection);
let $7a958506415603f3$var$styleNumber = 0;
function $7a958506415603f3$var$createMVTStyle(color = "purple") {
    return [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: color,
                width: 4
            })
        })
    ];
}
const $7a958506415603f3$var$allStyles = [
    $7a958506415603f3$var$createMVTStyle(),
    $7a958506415603f3$var$createMVTStyle("red")
];
function $7a958506415603f3$var$createMVTLayer(url, maxZoom) {
    const source = new (0, $2Jpez.default)({
        url: url,
        attributions: "Schweizmobil",
        format: new (0, $3p15R.default)()
    });
    const styles = $7a958506415603f3$var$allStyles[$7a958506415603f3$var$styleNumber];
    // const swissExtentDegrees = [5.2, 45.45, 11, 48];
    // source.set('olcs_provider', new MVTImageryProvider({
    //   credit: new Cesium.Credit('Schweizmobil', false),
    //   urls: [url],
    //   styleFunction: () => styles,
    //   rectangle: new Cesium.Rectangle(...swissExtentDegrees.map(Cesium.Math.toRadians)),
    //   minimumLevel: 6,
    // }));
    source.set("olcs_skip", false);
    source.set("olcs_minimumLevel", 6);
    return new (0, $4IEkJ.default)({
        source: source,
        extent: [
            572215,
            5684416,
            1277662,
            6145307
        ],
        opacity: 0.6,
        style: styles
    });
}
const $7a958506415603f3$export$b77f68ebb8e627a0 = $7a958506415603f3$var$createMVTLayer("https://map.schweizmobil.ch/api/4/mvt_routes/wander/3857/{z}/{x}/{y}.pbf?olcs", 20);
function $7a958506415603f3$var$createOSMLayer() {
    const source = new (0, $9jDAx.default)();
    //source.set('olcs_provider', new Cesium.OpenStreetMapImageryProvider());
    return new (0, $4mWlF.default)({
        source: source
    });
}
const $7a958506415603f3$var$ol2d = new (0, $5DwXE.default)({
    layers: [
        $7a958506415603f3$var$createOSMLayer(),
        $7a958506415603f3$export$b77f68ebb8e627a0
    ],
    target: "map",
    view: new (0, $9DiKA.default)()
});
const $7a958506415603f3$var$ol3d = new (0, $cc3xD.default)({
    map: $7a958506415603f3$var$ol2d
});
setTimeout(()=>{
    $7a958506415603f3$var$ol3d.setEnabled(true);
});
const $7a958506415603f3$var$EXTENT = [
    572215,
    5684416,
    1277662,
    6145307
];
const $7a958506415603f3$var$padding = -50000;
$7a958506415603f3$var$ol2d.getView().fit([
    $7a958506415603f3$var$EXTENT[0] - $7a958506415603f3$var$padding,
    $7a958506415603f3$var$EXTENT[1] - $7a958506415603f3$var$padding,
    $7a958506415603f3$var$EXTENT[2] + $7a958506415603f3$var$padding,
    $7a958506415603f3$var$EXTENT[3] + $7a958506415603f3$var$padding
]);
document.getElementById("enable").addEventListener("click", ()=>$7a958506415603f3$var$ol3d.setEnabled(!$7a958506415603f3$var$ol3d.getEnabled()));
document.getElementById("toggle").addEventListener("click", ()=>{
    $7a958506415603f3$var$styleNumber = ($7a958506415603f3$var$styleNumber + 1) % 2;
    $7a958506415603f3$export$b77f68ebb8e627a0.setStyle($7a958506415603f3$var$allStyles[$7a958506415603f3$var$styleNumber]);
});


//# sourceMappingURL=mvt.27a7bad5.js.map
